export const CONVERSATION_MODAL_LAYER = 'conversation';
export const EDIT_CONVERSATION_MODAL_LAYER = 'edit';

export const config = {
  aliases: {
    [CONVERSATION_MODAL_LAYER]: 1,
    [EDIT_CONVERSATION_MODAL_LAYER]: 2,
  },
};
